<template>
  <div>
	<iframe :src="url"></iframe>
  </div>
</template>

<script>
import { handleLocalStorage } from '@/utils';
export default {
  name: "payWebview",
  props: {},
  data() {
    return {
      url: "",
    };
  },
  onLoad(option) {
    const wappay_url = handleLocalStorage.get('wappay_url')
    this.url = decodeURIComponent(wappay_url);
  },
};
</script>

<style lang="scss">
</style>
